var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutDashboard',{attrs:{"title":"Vendas"}},[_c('ListarVendaCard',{attrs:{"botaoVisualizarVenda":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }